module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Login","username":"Username","password":"Password"},"fa":{"login":"ورود","username":"نام کاربری","password":"کلمه عبور"},"ps":{"login":"د ننه کیدل","username":"کارن نوم","password":"رمز"}}')
  delete Component.options._Ctor
}
